// extracted by mini-css-extract-plugin
export default {"module":"DCOBlock-module__module___UrmBQ","articles":"DCOBlock-module__articles___GziEr"};